import { render, staticRenderFns } from "./incluir-tipo-deficiencia.vue?vue&type=template&id=20902a42&"
import script from "./incluir-tipo-deficiencia.vue?vue&type=script&lang=ts&"
export * from "./incluir-tipo-deficiencia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20902a42')) {
      api.createRecord('20902a42', component.options)
    } else {
      api.reload('20902a42', component.options)
    }
    module.hot.accept("./incluir-tipo-deficiencia.vue?vue&type=template&id=20902a42&", function () {
      api.rerender('20902a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tipo-deficiencia/incluir-tipo-deficiencia.vue"
export default component.exports